import { Button, Card, Col, Form, Input, Row, Table, Typography } from "antd";
import dayjs from "dayjs";
import React, { Fragment, useEffect, useState } from "react";
import { CSVLink } from "react-csv";
import { toast } from "react-toastify";
import ViewBtn from "../Buttons/ViewBtn";
import UserPrivateComponent from "../PrivateRoutes/UserPrivateComponent";
import ColVisibilityDropdown from "../Shared/ColVisibilityDropdown";
import { CsvLinkBtn } from "../UI/CsvLinkBtn";
import { addRole, getRoles } from "./roleApis";

function CustomTable({ list }) {
    const [columnsToShow, setColumnsToShow] = useState([]);

    const columns = [
        { id: 1, title: "S.No", dataIndex: "serial", key: "serial" },
        { id: 2, title: "Name", dataIndex: "name", key: "name" },
        {
            id: 3,
            title: "Created at",
            dataIndex: "createdAt",
            key: "createdAt",
            render: (createdAt) => dayjs(createdAt).format("YYYY-MM-DD"),
        },
        {
            id: 4,
            title: "Action",
            dataIndex: "id",
            key: "action",
            render: (id) => (
                <UserPrivateComponent permission={"readSingle-role"}>
                    <ViewBtn path={`/admin/role/${id}/`} />
                </UserPrivateComponent>
            ),
        },
    ];

    useEffect(() => {
        setColumnsToShow(columns);
    }, []);

    const columnsToShowHandler = (val) => {
        setColumnsToShow(val);
    };

    const addKeys = (arr) => arr.map((i, index) => ({ ...i, key: i.id, serial: index + 1 }));

    return (
        <Card>
            <div className="text-center my-2 flex justify-between">
                <h5 className="text-xl role-list-title mb-2">Role List</h5>
                {list && (
                    <div>
                        <CsvLinkBtn>
                            <CSVLink data={list} className="btn btn-dark btn-sm mb-1" filename="roles">
                                Download CSV
                            </CSVLink>
                        </CsvLinkBtn>
                    </div>
                )}
            </div>

            {list && (
                <div style={{ marginBottom: "30px" }}>
                    <ColVisibilityDropdown options={columns} columns={columns} columnsToShowHandler={columnsToShowHandler} />
                </div>
            )}

            <Table scroll={{ x: true }} loading={!list} columns={columnsToShow} dataSource={list ? addKeys(list) : []} />
        </Card>
    );
}

const AddRole = ({ drawer }) => {
    const [list, setList] = useState(null);
    const [loader, setLoader] = useState(false);

    useEffect(() => {
        getRoles()
            .then((d) => setList(d))
            .catch((error) => console.log(error));
    }, []);

    const { Title } = Typography;

    const onFinish = async (values) => {
        setLoader(true);
        const resp = await addRole(values);

        if (resp.message === "success") {
            setLoader(false);
            setList([...list, resp.data]);
        }
    };

    const onFinishFailed = () => {
        toast.warning("Failed at adding role");
        setLoader(false);
    };

    return (
        <Fragment bordered={false}>
            <UserPrivateComponent permission={"create-role"}>
                <Row className="mr-top" gutter={[16, 16]}>
                  
                    <Col xs={24} sm={24} md={10} lg={8} xl={6}>
                        <Card className="border rounded card-custom">
                            <Title level={4} className="text-center">
                                Add New Role
                            </Title>
                            <Form
                                name="basic"
                                labelCol={{ span: 6 }}
                                wrapperCol={{ span: 16 }}
                                onFinish={onFinish}
                                onFinishFailed={onFinishFailed}
                                autoComplete="off"
                            >
                                <Form.Item
                                    label="Name"
                                    name="name"
                                    rules={[{ required: true, message: "Please input role name!" }]}
                                >
                                    <Input />
                                </Form.Item>

                                <Form.Item wrapperCol={{ offset: 6, span: 16 }}>
                                    <Button type="primary" size="large" htmlType="submit" block loading={loader}>
                                        Add New Role
                                    </Button>
                                </Form.Item>
                            </Form>
                        </Card>
                    </Col>

                    {/* Right Side - Table */}
                    <Col xs={24} sm={24} md={14} lg={16} xl={18}>
                        <UserPrivateComponent permission={"readAll-role"}>
                            <CustomTable list={list} />
                        </UserPrivateComponent>
                    </Col>
                </Row>
            </UserPrivateComponent>
        </Fragment>
    );
};

export default AddRole;
